import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import { Container, Row, Col } from "react-bootstrap";
const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const UploadLogo = ({ register, fieldName, title, currentLogo, bgColor, setFile, width }) => {
  const hiddenInputRef = useRef();

  const { ref: registerRef } = register(fieldName);

  const [preview, setPreview] = useState(currentLogo ? BACKEND_URL + "/uploads/subsites/" + currentLogo : null);

  const handleUploadedFile = (event) => {
    const file = event.target.files[0];
    console.log("FILE", file);
    setFile(file);
    const urlImage = URL.createObjectURL(file);

    setPreview(urlImage);
  };

  return (
    <Container fluid style={{ backgroundColor: bgColor ? bgColor : "#000000", color: "#FFFFFF" }} >
      <Row>
        <Col>
          <Form.Label className="sectionTitle">{title}</Form.Label>
        </Col>
      </Row>
      {currentLogo && currentLogo.imageUrl && (
        <Row>
          <Col>
            Current Image:<br />
            <img src={BACKEND_URL + currentLogo.imageUrl} alt="Old logo image" height="100" />
          </Col>
        </Row>
      )}
      <Row>
        <Col style={{padding: 15}}>
          <input
            type="file"
            accept="image/*,.png,.jpg,.jpeg"
            id={fieldName}
            name={fieldName}
            {...register(fieldName)}
            onChange={handleUploadedFile}
            ref={(e) => {
              registerRef(e);
              hiddenInputRef.current = e;
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col style={{padding: 15}}>
        {preview && <Image src={preview} alt="logo image" style={{ width: width ? width : 100 }} />}
        </Col>
      </Row>
    </Container>
  );
};

export default UploadLogo;
